
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host .jump-here {
        visibility:hidden;
}
  :host .jump-here {
        position:absolute;
}
  :host ghs-icon {
        transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
        transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
        transition-property:color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
        transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
        transition-duration:150ms;
}
  :host ghs-icon {
        transition-duration:300ms;
}
  :host .back-to-top {
        margin-bottom:0.75rem;
}
  :host .back-to-top {
        display:flex;
}
  :host .back-to-top {
        align-items:center;
}
  :host .back-to-top {
        justify-content:flex-end;
}
  :host .back-to-top {
        gap:0.5rem;
}
  :host .back-to-top {
        color:var(--bh-brand-primary-default-compatibility);
}
  :host .back-to-top {
        text-decoration-line:none;
}
  @media (min-width: 768px) {
        :host .back-to-top {
                gap:1rem;
        }
}
  :host .back-to-top:hover, :host .back-to-top:focus {
        cursor:pointer;
}
  :host .back-to-top:hover, :host .back-to-top:focus {
        text-decoration-line:underline;
}
  :host .back-to-top:hover ghs-icon, :host .back-to-top:focus ghs-icon{
        transform:translateY(-40%);
      }
`;